<template>
	<div class="submitWrapper paddBottom">
		<IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
		<div class="main">
			<!-- <div class="diqiu1" :style="{width:b / 3.5 + 'px',height:b / 4 + 'px',right:b / 15 + 'px '}">
				<img src="@/assets/slices_slices/4.svg" alt="" :style="{width:b / 3.5 + 'px',height:b / 4 + 'px'}" />
			</div>
			<div class="feixingqi2">
				<img src="@/assets/slices_slices/people.png" alt="" />
			</div>
			<div class="feixingqi"  :style="{width:b / 6 + 'px',height:b / 4 + 'px',right:b / 15 + 'px '}">
				<img src="@/assets/slices_slices/7.svg" alt=""  :style="{width:b / 6 + 'px',height:b / 4 + 'px',right:b / 15 + 'px '}" />
			</div>
			<div class="diqiu2" :style="{width:b / 6 + 'px',height:b / 4.4 + 'px',bottom:-(b / 30) + 'px',right:b / 13 + 'px '}">
				<img src="@/assets/slices_slices/8.svg" alt="" :style="{width:b / 6 + 'px',height:b / 4.4 + 'px'}" />
			</div> -->
			<div class="oneCard">
				<!-- <div v-html="description" style="overflow-x: hidden;"></div> -->
				<!-- {{description}} -->
				<h3 style="font-size: 30px;">Introduction of AstroBurstHub</h3>
				<div style="font-size: 20px;">
					AstroBurstHub is the abbreviation for Astronomical Burst Hub, which is designed to get together all astronomical burst <router-link to="/Events" style="color: #168EC7;">Events</router-link>, such as Gamma-Ray Burst (GRB), Soft Gamma-ray Repeater (SGR), Fast Radio Burst (FRB), Gravitational Wave (GW) and High Energy Neutrino (HEN), from various platforms which collect and distribute <router-link to="/message" style="color: #168EC7;">Messages</router-link> publicly. These platforms include Gamma-ray Coordinates Network (GCN), The Astronomer's Telegram (ATEL), and other public resources.
				</div>
				<div style="font-size: 20px;margin-top: 20px;">
					In the era of multi-messenger multi-wavelength astronomy, it is of critical importance to make joint observations with various telescopes and instruments in a timely manner. These observations usually will be reported as various types of Messages in different platforms, which is somewhat inconvenient for researchers. We collect these Messages from various platform and group them into astronomical burst Events. An Event corresponds to a burst activity of the celestial object, which may be observed by one or multiple telescopes and instruments. Observations of an Event may result in one or multiple Messages. We also provide statistics of all and the latest Events and Messages and highlight the most popular Events (called Hot Events). We hope this website will provide helpful information to researcher and facilitate the study of astronomical bursts.
				</div>
				<div style="font-size: 20px;margin-top: 20px;">
					The purpose of establishing this "AstroBurstHub" website is solely for opened scientific research and public interest. All Messages are collected from public platforms and resources. We sincerely thank all authors and platforms who shared their Messages publicly. All copyrights and credits should be given to the original authors and platforms of these Messages. 
				</div>
				<div style="font-size: 20px;margin-top: 20px;">
					In this website, all information and links are given for reference purpose only, and we explicitly state that any responsibility for damage, loss or injury is excluded which a person or institution may experience while using these information or links. 
				</div>
				<div style="font-size: 20px;margin-top: 20px;">
					This website is fully open for collaboration. Should you have any comment and suggestion, please do not hesitate to contact us.
				</div>
			</div>
			<img src="@/assets/slices_slices/2.svg" alt="" class="beijingtu" />
		</div>
	</div>
</template>

<script>
	import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
	export default{
		name: "about",
		components: {
			IndexHeaderOthers,
		},
		data(){
			return{
				b:'',
				c:'',
				description:'',
				a:''
			}
		},
		mounted() {
			this.getList()
			this.getIndexData()
		},
		methods:{
			getList(){
				this.$fetchGet("/cms-middle/cmsSite/config?type=about")
					.then((result) => {
						console.log(result)
						this.description = result.config.about.description
						// this.description = ``
					})
					.catch((err) => {});
			},
			getIndexData() {
				let a = document.getElementsByClassName('main')
				console.log(a)
				this.b = a[0].clientWidth
				this.c = this.b * 525 / 1920
				console.log(this.c)
				document.getElementsByClassName('is-active').style.width = this.b
			},
		}
	}
</script>

<style lang="less" scoped>
	.main {
		position: relative;
		margin-top: -70px;
		z-index: 99;
		width: 100%;
		height: 900px;
		background: #fff;
		border-radius: 0 120px 0 0;
		// background: url(@/assets/slices_slices/2.svg) no-repeat center center;
	}
	.beijingtu{
		position:absolute;
		top:0;
		bottom:0;
		left:0;
		right:0;
		margin:auto;
		z-index:-10;
		width: 100%;
		height: 1000px;
	}
	.submitWrapper{
		width: 100%;
	}
	.diqiu1{
		position: absolute;
		top: -100px;
		right: 10px;
	}
	.feixingqi{
		position: absolute;
		left: 100px;
		top: 35%;
	}
	.feixingqi2{
		position: absolute;
		left: 30%;
		top: 30%;
	}
	.diqiu2{
		position: absolute;
		bottom: -10px;
		right: 10px;
	}
	.oneCard {
		width: 950px;
		height: 728px;
		background: rgba(204, 204, 204, 0.3);
		box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.1);
		border-radius: 11px 11px 11px 11px;
		position: absolute;
		z-index: 99;
		left: 0;
		right: 0;
		top: -40px;
		bottom: 0;
		margin: auto;
		padding: 10px !important;
		overflow: auto;
		font-size: 24px;
		text-align: left;
	}
	.oneCard h3{
			text-align: center;
	}
	.oneCard::-webkit-scrollbar { width: 0 !important }
</style>